import type { FieldValues, SubmitHandler } from "react-hook-form"
import { useFormContext } from "react-hook-form"
import PageLeave from "./PageLeave"

type Props<TValues extends FieldValues> = {
  autoSave: boolean
  onSubmit: SubmitHandler<TValues>
  confirmMessage?: string
}

export default function FormPageLeave<TValues extends FieldValues>({
  autoSave,
  onSubmit,
  confirmMessage,
}: Props<TValues>) {
  const {
    handleSubmit,
    formState: { isDirty, isValid },
  } = useFormContext<TValues>()

  return (
    <PageLeave
      autoSave={autoSave}
      save={handleSubmit(onSubmit)}
      isDirty={isDirty}
      isValid={isValid}
      confirmMessage={confirmMessage}
    />
  )
}
